<template>
	<div class="convertion__title" :class="item.document_id ? '' : 'convertion__title-or'" 
	:title="item.document_id ? `Отправлен в МСЭД. Document_ID=${item.document_id}`: 'В СЭД не отправлен'">
		<div class="convertion__date">
			{{ item.date_ip }}
		</div>
		Исх.№:
		<RouterLink :to="`${basePath}/check?uid=${item.uid}`" class="convertion__rep">
			{{ item.uid }}
		</RouterLink>
		<div>{{ item.registered_number }}</div>
		<div class="convertion__ip text-right">{{ item.ip }}</div>
	</div>
	<div class="convertion__name">
		<div class="convertion__name-link">
			{{ item.theme }}
		</div>
		<div class="convertion__author">
			<span class="convertion__author">
				{{ item.fio }}
			</span>
			<span>
				{{ item.email }}
			</span>
		</div>
	</div>
	<div class="convertion__send"><i>{{ item.zone_name }}</i></div>
</template>

<script>
import { getConfig } from "@/auth";

export default {
	props: [
		'item'
	],
	data: function() {
		return {
			urlPDF: getConfig().appealsUrl,
			basePath: getConfig().basePath
		}
	}
}
</script>